import NewsletterFormProvider from './hooks/useNewsletterForm';
import React from 'react';
import ButtonStateProvider from './hooks/useButtonState';
import { NewsletterFormProps } from './@types/NewsletterFormProps';
import NewsletterFormContainer from './handles/NewsletterFormContainer';

const NewsletterForm = (props: NewsletterFormProps) => {
	const [state, setState] = React.useState('default');

	return (
		<ButtonStateProvider {...{ state, setState }}>
			<NewsletterFormProvider {...props}>
				<NewsletterFormContainer {...props} />
			</NewsletterFormProvider>
		</ButtonStateProvider>
	);
};

export default NewsletterForm;
